import { Stack, Typography } from '@mui/material';
import { LineChart } from '@mui/x-charts/LineChart';

interface LineChartComponentProps {
    data: number[];
    height?: number;
    label?: string;
    labels: string[];
    showMarkers: boolean;
    title: string;
}

function LineChartComponent({
    data,
    height = 280,
    label = 'Metric',
    labels,
    showMarkers,
    title,
}: Readonly<LineChartComponentProps>) {
    return (
        <Stack
            sx={{
                flex: 1,
            }}
        >
            <Typography sx={{ mb: 1 }} variant="subtitle2">
                {title}
            </Typography>
            <LineChart
                height={height}
                series={[
                    {
                        area: true,
                        data,
                        label: label || undefined,
                        showMark: showMarkers,
                    },
                ]}
                xAxis={[
                    {
                        data: labels,
                        scaleType: 'point',
                    },
                ]}
                yAxis={[
                    {
                        min: 0,
                    },
                ]}
            />
        </Stack>
    );
}

export default LineChartComponent;
